import { Component } from '@angular/core';
import { BuilderModule } from '@builder.io/angular';
import { BuilderDependencyDirective } from '@scalefast/ecommerce-core';

@Component({
  imports: [BuilderModule, BuilderDependencyDirective],
  standalone: true,
  selector: 'app-page-builder-container',
  styleUrls: [],
  template: ` <builder-component sfBuilderDependency name="page" [model]="'page'" /> `,
})
export class AppPageContainerComponent {}
